import { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";

export default function useFemaleProfile() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = auth.currentUser;

    if (!user) {
      setProfile(null);
      setLoading(false);
      return;
    }

    const ref = doc(db, "users", user.uid);

    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (!snap.exists()) {
          setProfile(null);
          setLoading(false);
          return;
        }

        const data = snap.data() || {};

        const availableUsd = Number(data?.earnings?.availableUsd ?? 0);
        const availableTokens = Number(data?.earnings?.availableTokens ?? 0);

        const femaleLevel = Number(data?.femaleLevel ?? 0);

        const levelingTokens = Number(
          data?.leveling?.tokens ??
            data?.leveling?.cycleTokens ??
            data?.leveling?.progressTokens ??
            0
        );

        const activeDays = Number(
          data?.leveling?.activeDays ??
            data?.leveling?.cycleActiveDays ??
            0
        );

        const lastActiveDay = data?.leveling?.lastActiveDay ?? "";
        const requiredActiveDays = Number(
          data?.leveling?.requiredActiveDays ?? 0
        );

        const cycleStartedAt = data?.leveling?.cycleStartedAt ?? null;

        setProfile({
          ...data,

          earnings: {
            ...(data?.earnings || {}),
            availableUsd,
            availableTokens,
          },

          leveling: {
            ...(data?.leveling || {}),
            tokens: levelingTokens,
            activeDays,
            lastActiveDay,
            requiredActiveDays,
            cycleStartedAt,
          },

          femaleLevel,
        });

        setLoading(false);
      },
      (error) => {
        console.error("❌ useFemaleProfile error:", error);
        setProfile(null);
        setLoading(false);
      }
    );

    return () => unsub();
  }, []);

  return { profile, loading };
}